import { css } from '@emotion/react';
import AthenaTextInput, {
  AthenaTextInputType,
} from 'athena/components/text-input';
import { gray5 } from 'styles/global_defaults/colors';
import {
  extraLargeSpacing,
  standardSpacing,
  tripleSpacing,
} from 'styles/global_defaults/scaffolding';
import { useRef } from 'react';
import { useFormContext } from 'react-hook-form';
import { debounce } from 'lodash';
import { config } from '@config/pendo.config.json';

type BrowseMentorsSearchProps = {
  placeholder: string;
};

const browseMentorsSearchStyles = css`
  flex-shrink: 0;
  height: ${tripleSpacing}px;
  padding: ${standardSpacing}px;
  border-bottom: 1px solid ${gray5};

  .search-input {
    padding-right: ${extraLargeSpacing}px !important;
    outline: 0px solid transparent !important;
  }
`;

const BrowseMentorsSearch = ({ placeholder }: BrowseMentorsSearchProps) => {
  const { watch, setValue } = useFormContext();
  const searchTerm = watch('search');

  const debouncedSetSearchTerm = useRef(
    debounce((value) => {
      setValue('search', value, { shouldValidate: false });
    }, 500)
  ).current;

  const dataQATag =
    config.pendo.athena.mentorshipProgram.participantHome.findAMentor.modal.searchMentorInputField;

  return (
    <div css={browseMentorsSearchStyles} className='d-flex align-items-center'>
      <AthenaTextInput
        icon='search'
        type={AthenaTextInputType.SEARCH}
        value={searchTerm}
        showLabel={false}
        showClearLabel
        className='w-100'
        inputClassName='border-0 search-input'
        onChange={(e) => debouncedSetSearchTerm(e.target.value)}
        placeholder={placeholder}
        dataQa={dataQATag}
      />
    </div>
  );
};

export default BrowseMentorsSearch;
